import { Inject, Injectable } from '@angular/core';
import { ToastItem } from '@inscomponents/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { FormState } from '../form-state';
import { FormStateHandler } from './form-state-handler';

export interface DataHasChangedErrorContext {
    reloadAction(): Promise<void>;
}

@Injectable({providedIn: 'root'})
export class DataHasChangedErrorHandler extends FormStateHandler<DataHasChangedErrorContext> {
    public constructor(
        private readonly toastService: ToastService,
        @Inject(L10n) private readonly l10n: L10nBase
    ) {
        super();
    }

    protected get formState(): FormState {
        return FormState.DataHasChangedError;
    }

    protected handle(ctx: DataHasChangedErrorContext): void {
        let close: () => void;
        const options = this.getToastOptions(ctx, () => close?.());

        this.toastService.showAsync({
            duration: undefined,
            ...options
        }).then(closer => close = closer);
    }

    protected getToastOptions(ctx: DataHasChangedErrorContext, close: () => void): ToastItem {
        return {
            type: 'error',
            text: this.l10n._T('scenes.shared.toast.form-state-context.data-has-changed-error.message'),
            actions: [
                {
                    text: this.l10n._T('scenes.shared.toast.form-state-context.data-has-changed-error.buttons.reload'),
                    handler: async () => {
                        await ctx.reloadAction();
                        close();
                    }
                },
                {
                    text: this.l10n._T('scenes.shared.toast.form-state-context.data-has-changed-error.buttons.do-nothing'),
                    handler: close
                }
            ],
        };
    }
}
